@if (author) {
  <div class="container author-shell">
    <div class="main-content">
      <div class="layout-column">
        <div class="author-details layout-row">
          <div class="layout-column full-w">
            <div class="layout-row align-end space-between">
              <div class="layout-column">
                <img class="author-avatar spacer-right-16" [src]="author.authorImageUrl" [alt]="author.fullName" width="50px" height="50px">
                <h1>{{author.fullName}}</h1>
              </div>
              <div>
                <span class="medium">{{author.title}}</span>
              </div>
            </div>
            <div class="h-separator"></div>
            <div class="layout-row space-between">
              <p class="author-description">{{author.description}}</p>
              <!-- <a [href]="'mailto:' + author.email" [title]="'Email: ' + author.fullName">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" heigh="24" viewBox="0 0 24 24">
                <path fill="#284154" d="M0,3v18h24V3H0z M21.2,4.5L12,11.1L2.8,4.5H21.2z M22.5,19.5h-21V5.4L12,12.9l10.5-7.5V19.5z" />
              </svg>
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container layout-row">
  <h2 class="author-more">More by this author</h2>
</div>
<div class="container layout-row flex-wrap">
  @for (item of articlesByAuthor; track item) {
    <div class="flex-half-tablet spacer-bottom-40">
      <div class="author-snippet">
        <gh-snippet-mobile [article]="item" class="snippet-wrapper"></gh-snippet-mobile>
      </div>
    </div>
  }
</div>
<gh-pagination [pager]="pager" type="author" [entity]="author" [currentPage]="currentPage"></gh-pagination>
<div class="bgr-light-grey category-section">
  <gh-category-menu-section>
  </gh-category-menu-section>
</div>
}
